import { } from "angular"
import { Address } from "@idha/idha-types"
import { utilsModule } from "../utils-module";

var CPF = require("@fnando/cpf/dist/node");
var CNPJ = require("@fnando/cnpj/dist/node");
var cpfCnpj: IBaseCpfCnpjService = {
    isValid: function (str: string) {
        if (!str || (str.length == 0)) return true;

        return CPF.isValid(str, true) || CNPJ.isValid(str, true)

        /*if(str.length == 14){
            return CNPJ.isValid(str);
        }else if(str.length == 11){
            return CPF.isValid(str);
        }else{
          return false
        }*/
    },
    format: function (str: string) {
        return CNPJ.isValid(str, true) ? CNPJ.format(str) : CPF.format(str)
    },
    strip: function (str: string) {
        return CNPJ.strip(str);
    }
}

export { Address }

/**
 * IDHA TECNOLOGIA
 * Criação: 21/03/2019
 * 
 * Descrição:
 * 
 * Serviços para validação de CPF e CNPJ
 * 
 * 
 * @author William Azevedo de Paula
 */


/**
  * @ngdoc service
  * @name app.cpf
  * 
  * @description
  * Injeta uma instância de @fnando/cpf para realizar validações de CPF
  *
  * @example
  * cpf.isValid('109.940.286.79')
**/
utilsModule.factory('cpf', [function () {
    return CPF;
}]);


/**
  * @ngdoc service
  * @name app.cpf
  * 
  * @description
  * Injeta uma instância de @fnando/cnpj para realizar validações de CPF
  *
  * @example
  * cnpj.isValid('26.078.596/0001-36')
**/
utilsModule.factory('cnpj', [function () {
    return CNPJ;
}]);

/**
  * @ngdoc service
  * @name app.cpf
  * 
  * @description
  * Aplica o validador de CNPJ ou CPF, conforme o tamanho do dado sendo validado (se tiver 14 caracteres, aplica validação de CNPJ.
  * Caso contrário, aplica a validação de CPF)
  *
  * @example
  * cnpj.isValid('26.078.596/0001-36')
**/
utilsModule.factory('cpfCnpj', [function () {
    return cpfCnpj;
}]);




/**
 * @interface
 * @name app.IBaseCpfCnpjService
 * @author William Azevedo de Paula
 * @description
 * Interface implementada pelos serviços de validação de CPF e CNPJ.
 */
interface IBaseCpfCnpjService {
    /**
     * @method
     * @methodOf IBaseCpfCnpjService
     * @name app.IBaseCpfCnpjService#isValid
     * Valida uma string, conforme o serviço de validação utilizado (cpf, cnpj, ou ambos)
     * @param {string} str a string contendo o CPF/CNPJ a serem valdiados
     * @return {boolean} true se a string for válida para o formato (cpf, cnpj, ou ambos), ou false caso contrário
     */
    isValid: (str: string) => boolean
    /**
     * @method
     * @methodOf IBaseCpfCnpjService
     * @name app.IBaseCpfCnpjService#strip
     * Remove formatação de um CPF/CNPJ
     * @param {string} str a string contendo o CPF/CNPJ a ter máscara/formatação removida
     * @return {string} a string sem formatação
     */
    strip: (str: string) => string
    /**
     * @method
     * @methodOf IBaseCpfCnpjService
     * @name app.IBaseCpfCnpjService#format
     * Aplica a formatação devida em uma string
     * @param {string} str a string sem formatação
     * @return {string} a string formatada
     */
    format: (str: string) => string
}
/**
 * @interface
 * @name app.ICpfCnpj
 * @author William Azevedo de Paula
 * @description
 * Interface implementada pelo serviço de validação de CPF ou CNPJ. 
 * A devida formatação/validação é aplicada conforme o tamanho da strig
 */
export interface ICpfCnpj extends IBaseCpfCnpjService { }
/**
 * @interface
 * @name app.ICpf
 * @author William Azevedo de Paula
 * @description
 * Interface implementada pelos serviço de validação de CPF
 */
export interface ICpf extends IBaseCpfCnpjService { }
/**
 * @interface
 * @name app.ICnpj
 * @author William Azevedo de Paula
 * @description
 * Interface implementada pelos serviço de validação de CNPJ
 */
export interface ICnpj extends IBaseCpfCnpjService { }
